import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _mcsNames;

import { ETargetPage } from '../types';
/**
 * С помощью константы определяем поле key (название мкс) в отправляемой телеметрии
 * */

export var mcsNames = (_mcsNames = {}, _defineProperty(_mcsNames, ETargetPage.valuation, 'realty-valuation-frontend'), _defineProperty(_mcsNames, ETargetPage.valuationResults, 'realty-valuation-result-frontend'), _defineProperty(_mcsNames, ETargetPage.newBuilding, 'realty-valuation-newbuilding-frontend'), _defineProperty(_mcsNames, ETargetPage.valuationAgentResults, 'valuation-for-agent-frontend'), _defineProperty(_mcsNames, ETargetPage.valuationForAgentCalculatorPage, 'valuation-for-agent-frontend'), _defineProperty(_mcsNames, ETargetPage.realtorPromo, 'select-realtor-promo-frontend'), _mcsNames);